import React from 'react';
import { Link } from 'react-router-dom';

const posts = [
    // { slug: 'time-series-db-from-scratch', title: 'A Testament to the Grind: Building a Time-Series Database From Scratch' },
    // { slug: 'you-dont-know-rest', title: "You don't know REST" },
    { slug: 'oop-in-the-modern-age-when-memory-is-no-longer-a-concern', title: "[WIP] OOP In The Modern Age: When Memory is No Longer a Concern" },
    // { slug: 'discrete-structures', title: 'Discrete Structures' },
    // { slug: 'second-post', title: 'Second Post' },
];

const Blog = () => {
    return (
        <div>
            <h1>Blog</h1>
            <ul>
                {posts.map((post) => (
                    <li key={post.slug}>
                        <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Blog;
